import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {CircularProgress} from "@mui/material";
import {useTheme} from "@mui/material/styles";

import RightDrawerDesktop from "components/WMS/Desktop/RightDrawerDesktop";

import JournalEntry from "./JournalEntry";

import {black500, blueColor, greyishBlue500} from "assets/jss/main";

ModificationLogDrawer.propTypes = {
    logs: PropTypes.array,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onLoadMore: PropTypes.func,
    loadingMore: PropTypes.bool,
    hasMore: PropTypes.bool
};

function ModificationLogDrawer({logs = [], open = false, onClose = () => {}, onLoadMore = () => {}, loadingMore = false, hasMore = true}) {
    const theme = useTheme();

    return (
        <RightDrawerDesktop
            open={open}
            onClose={onClose}
            zIndex={theme.zIndex.modal + 2}
            squareCorners
            blurredBackdrop
            customWidth={"min(500px, 100vw)"}
            customHeaderPadding={"0 72px 8px 24px"}
            customContentPadding={"24px"}
            withoutHeadBorder={true}
            title={(
                <div>
                    <div style={{
                        fontSize: '24px',
                        fontWeight: 700,
                        color: black500
                    }}>
                        <FormattedMessage id='product.show.modificationLog.title' />
                    </div>
                </div>
            )}
            subtitle={(
                <div style={{
                    fontSize: '16px',
                    fontWeight: 400,
                    color: greyishBlue500
                }}>
                    <FormattedMessage id='product.show.modificationLog.drawer.subtitle' />
                </div>
            )}
        >
            {logs.map((log) => (
                <JournalEntry
                    key={log.id}
                    action={log.action}
                    field={log.field}
                    variationSku={log.sku}
                    oldValue={log.oldValue}
                    newValue={log.newValue}
                    date={log.date}
                    author={log.user.firstName}
                />
            ))}

            {loadingMore && (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    padding: '4px 0'
                }}>
                    <CircularProgress size={16} />
                </div>
            )}

            {!loadingMore && hasMore && (
                <span
                    onClick={onLoadMore}
                    style={{
                        display: 'block',
                        textAlign: 'center',
                        width: '100%',
                        color: blueColor,
                        fontSize: '14px',
                        cursor: 'pointer',
                        fontWeight: 400
                    }}>
                    <FormattedMessage id='product.show.modificationLog.loadMore' />
                </span>
            )}
        </RightDrawerDesktop>
    );
}

export default ModificationLogDrawer;
